import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { UserIntent, UserProfile } from '../types';
import { logAmplitudeEvent } from 'src/utils/analytics';

export const useRedirectHandler = () => {
  const history = useHistory();

  const executeRedirect = useCallback(
    (intent: UserIntent, profile: UserProfile) => {
      let redirectURL = '';
      const baseUrl = new URL(window.location.href).origin;
      if (!intent) {
        redirectURL = `${baseUrl}/airbnb-data/landing`;
      } else if (intent.context?.landingPage) {
        redirectURL = intent.context?.landingPage;
      } else {
        switch (intent.intent) {
          case 'explore_markets':
            redirectURL = `${baseUrl}/markets/compare`;
            break;
          case 'compare_markets':
            redirectURL = `${baseUrl}/airbnb-data/landing`;
            break;
          case 'analyze_market':
            redirectURL = `${baseUrl}/airbnb-data/landing`;
            break;
          case 'analyze_property':
            redirectURL = `${baseUrl}/airbnb-calculator`;
            break;
          case 'benchmark_listings':
            redirectURL = `${baseUrl}/airbnb-data/landing`;
            break;
          default:
            redirectURL = `${baseUrl}/airbnb-data/landing`;
        }
      }
      window.location.href = redirectURL;

      trackRedirect(intent, profile, redirectURL);
    },
    [history]
  );

  return { executeRedirect };
};

const trackRedirect = (intent: UserIntent, profile: UserProfile, redirectURL: string) => {
  const trackingData = {
    userType: profile.userType,
    strategy: profile.strategy || '',
    goal: profile.goal || '',
    intentType: intent.intent,
    redirectUrl: redirectURL,
  };
  logAmplitudeEvent('goal_redirection', { ...trackingData });
};
